var _mask, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStudentHatIcon = function SvgStudentHatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 69,
    viewBox: "0 0 84 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79 25h2v34a1 1 0 1 1-2 0V25Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79 25v-2h-2v2h2Zm2 0h2v-2h-2v2Zm-2 0v2h2v-4h-2v2Zm2 0h-2v34h4V25h-2Zm-2 34h2V25h-4v34h2Zm1 1v-2a1 1 0 0 1 1 1h-4a3 3 0 0 0 3 3v-2Zm1-1h-2a1 1 0 0 1 1-1v4a3 3 0 0 0 3-3h-2Z",
    fill: "#2C112D",
    mask: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.03 1.436a1 1 0 0 1 .985-.015L80.2 22.822a1 1 0 0 1-.024 1.768L40.988 44.627a1 1 0 0 1-.936-.014L3.569 24.577a1 1 0 0 1-.024-1.74L40.029 1.437Z",
    stroke: "#2C112D",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 31v20.837a2 2 0 0 0 1.011 1.738l23.537 13.383a2 2 0 0 0 1.921.031l25.464-13.426A2 2 0 0 0 68 51.793V31",
    stroke: "#2C112D",
    strokeWidth: 2
  })));
};
export default SvgStudentHatIcon;